import React, { Component } from 'react';
import renderHTML from 'react-render-html';
import Link from '../../common/TrackedLink';

class Certification extends Component {
	render() {
		return (
			<section className="row certification">
				<div className="col">
					<h2>{ this.props.header }</h2>
				</div>
				<div className="col descr">
					<p>{ renderHTML(this.props.subHeader) }</p>
				</div>
				<div className="row">
					<div className="col sm-6">
						<div className="icon">
							<img
								src={ this.props.imgSrc1 }
								alt={ this.props.alt1 }
							/>
						</div>
						<h3>{ renderHTML(this.props.title1) }</h3>
						<p>{ renderHTML(this.props.content1) }</p>
						<Link
							className="arrow-link"
							to={ this.props.link1Url }
						>
							{ this.props.link1Text }
						</Link>
					</div>
					<div className="col sm-6">
						<div className="icon">
							<img
								src={ this.props.imgSrc2 }
								alt={ this.props.alt2 }
							/>
						</div>
						<h3>{ renderHTML(this.props.title2) }</h3>
						<p>{ renderHTML(this.props.content2) }</p>
						<Link
							className="arrow-link"
							to={ this.props.link2Url }
						>
							{ this.props.link2Text }
						</Link>
					</div>
				</div>
			</section>
		);
	}
}

export default Certification;


// WEBPACK FOOTER //
// ./src/pages/category/common/Certification.js